<template>
  <div :class="customClass">
    <div class="cb-cart" :class="{'cb-cart--multiple': isMultipleCart}">
      <cb-slide-n-fade :is-list="true" :timeOut="true" :reCalculateMargin = "true">
      <line-item :readonly="readonly" :singleCart='!isMultipleCart' :item='item' :singleItem='isSingleItem' :currencyCode='currency_code' v-for="item in order_cart_items" v-bind:key="item.id" :useItem='true'></line-item>
      </cb-slide-n-fade>
      <slot name="addons"></slot>
    </div>
    <div class="cb-cart cb-cart--multiple cb-cart--footer cb-cart--footer-left" v-for="(coupon, index) in coupon_list" v-bind:key="index">
      <div class="cb-item--extras cb-transition__fade">
        <div class="cb-item__name" v-if="canShowDesc(coupon)">{{getCouponDesc(coupon)}}</div>
        <div v-if="canShowDesc(coupon) && coupon_enabled && !readonly && !isManualDiscount(coupon)" @click="removeDiscount(coupon.id)" class="cb-item__action" v-cb-link="'color'">{{ct('cart.remove')}}</div>
        <div class="tooltip" style="display: inline-flex" v-if="isManualDiscount(coupon)">
          <i class="icon-info-circle cb-notebar__muted info"></i>
          <span class="tooltiptext" v-cb-html="getDiscountTooltipMessage"></span>
        </div>
      </div>
    </div>
    <template v-if="canShowCoupon" ref="parent">
      <cb-discount></cb-discount>
    </template>
    <template v-if="canShowRecommendedAddon">
        <cb-recommended-addon></cb-recommended-addon>
    </template>
  </div>
</template>
<script type="text/javascript">
import {
  mapGetters
} from "vuex"
import LineItem from "@/components/modules/hosted-pages/LineItem"
import CartHelper from '@/utils/cart-helper'
import Discount from "@/components/modules/hosted-pages/DiscountComponent"
import RecommendedAddon from "@/components/modules/hosted-pages/RecommendedAddonComponent"
import {EventBus} from '@/utils/event-bus'
import CartMixin from "@/mixins/cart-mixin"
import HostedPageHelper from '@/utils/hosted-page-helper'

export default {
  components: {
    'line-item': LineItem,
    'cb-discount': Discount,
    'cb-recommended-addon': RecommendedAddon
  },
  props: ['customClass', 'readonly'],
  mixins: [CartMixin],
  computed: {
    ...mapGetters([
      'order_cart_items',
      'consolidated_discount',
      'currency_code',
      'coupon_enabled',
      'multi_coupon_enabled',
      'is_discount_present',
      'coupon_list'
    ]),
    isMultipleCart() {
      return this.order_cart_items.length > 1 || this.$store.getters.consolidated_tax || this.hasTieredPricing();
    },
    canShowCoupon() {
      return this.coupon_enabled && !this.readonly && (this.multi_coupon_enabled ? true : !this.is_discount_present);
    },
    canShowRecommendedAddon() {
      return this.$store.getters.can_allow('change-subscription.action.add_recommended_addons');
    },
    getDiscountTooltipMessage() {
      return this.$store.getters.get_text('hp_v3.discount.tooltip_message');
    }
  },
  methods: {
    getCouponDesc(coupon) {
      let output = {};
      output.coupon_id = coupon.id;
      output.title = coupon.details ? coupon.details.invoice_name || coupon.details.name : coupon.code;
      CartHelper.addSingleCouponDesc(output, this.coupon_list);
      return this.ct(this.isManualDiscount(coupon) ? 'discount.description' : 'coupon.description', {
        coupon_name: output.title,
        amount: output.description()
      });
    },
    canShowDesc(coupon) {
      let output = {};
      output.coupon_id = coupon.id;
      CartHelper.addSingleCouponDesc(output, this.coupon_list);
      if(typeof output.description == 'function') {
        return true;
      }
      return false;
    },
    isManualDiscount(item) {
      return HostedPageHelper.isManualDiscount(item);
    }
  }
}
</script>
<style lang="stylus" scoped>
  .cb-item{
    &__{
      &name{
        margin-right: 12px;
        width: auto !important;
      }
    }
  }
</style>
<style src="@/assets/styles/utils/tooltip.styl" lang="stylus"></style>